module.exports = __webpack_public_path__ + "static/img/store_16.891fd7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/store_16.png
// module id = NRSe
// module chunks = 1